import { useState } from "react";
import {
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { TbDotsVertical, TbLogout, TbUser } from "react-icons/tb";
import { Link } from "react-router-dom";

const getInitials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const menuItemSx = {
  py: 0.75,
  minHeight: 36,
  color: "text.primary",
  "&:hover": {
    backgroundColor: (theme) =>
      theme.palette.mode === "dark" ? "#1f1f1f" : theme.palette.action.hover,
  },
};

export const ProfileMenu = ({
  logout = () => { },
  isDisabled = false,
  accountData = {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const userName = accountData?.userName || "Usuário";
  const userEmail = accountData?.userEmail || "";

  return (
    <div className="flex items-center">
      <button
        type="button"
        onClick={handleClick}
        disabled={isDisabled}
        className="flex items-center gap-1 rounded-lg px-1 py-1 transition hover:bg-gray-50 disabled:opacity-50 dark:hover:bg-brand-dark-elevated sm:gap-3 sm:px-2"
      >
        <div className="hidden text-right sm:block">
          <p className="max-w-[200px] truncate text-sm font-semibold leading-tight text-brand-dark dark:text-gray-100">
            {userName}
          </p>
          {userEmail && (
            <p className="max-w-[200px] truncate text-xs leading-tight text-gray-500 dark:text-gray-400">
              {userEmail}
            </p>
          )}
        </div>
        <Avatar
          className="profile-menu-avatar"
          sx={{
            background: "var(--brand-avatar-bg, linear-gradient(135deg, #fcd177, #e7a73f))",
            color: "#fff",
            width: 36,
            height: 36,
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          {getInitials(userName)}
        </Avatar>
        <TbDotsVertical className="hidden h-5 w-5 text-brand-dark dark:text-gray-200 sm:block" />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          className: "app-card",
          sx: {
            mt: 1,
            minWidth: 240,
            borderRadius: 2,
            boxShadow: "0 4px 12px rgb(0 0 0 / 0.08)",
          },
        }}
      >
        <MenuItem disabled sx={{ py: 1.25, opacity: 1, cursor: "default", color: "text.primary" }}>
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Avatar
              className="profile-menu-avatar"
              sx={{
                background: "var(--brand-avatar-bg, linear-gradient(135deg, #fcd177, #e7a73f))",
                width: 32,
                height: 32,
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              {getInitials(userName)}
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary={userName}
            secondary={userEmail}
            primaryTypographyProps={{ fontSize: 12, fontWeight: 700, color: "inherit", noWrap: true }}
            secondaryTypographyProps={{ fontSize: 10, sx: { color: "text.secondary" }, noWrap: true }}
          />
        </MenuItem>
        <Divider />
        <Link to="/perfil" style={{ textDecoration: "none", color: "inherit" }}>
          <MenuItem onClick={handleClose} sx={menuItemSx}>
            <ListItemIcon sx={{ minWidth: 32, color: "inherit" }}>
              <TbUser className="h-[18px] w-[18px]" />
            </ListItemIcon>
            <ListItemText primary="Meu Perfil" primaryTypographyProps={{ fontSize: 13, color: "inherit" }} />
          </MenuItem>
        </Link>
        <MenuItem onClick={logout} sx={menuItemSx}>
          <ListItemIcon sx={{ minWidth: 32, color: "inherit" }}>
            <TbLogout className="h-[18px] w-[18px]" />
          </ListItemIcon>
          <ListItemText primary="Sair" primaryTypographyProps={{ fontSize: 13, color: "inherit" }} />
        </MenuItem>
      </Menu>
    </div>
  );
};

ProfileMenu.propTypes = {};
